import { Link as RouterLink } from "react-router";
import styled, { css } from "styled-components";

const LinkStyles = css`
  font-family: ${({ theme }) => theme.fonts.base};
  color: ${({ theme }) => theme.colors.white};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const Link = styled(RouterLink)`
  ${LinkStyles}
`;

export default Link;
